import { createReducer } from '@src/redux/helpers/createReducer';

import {
  SELECT_ADMIN,
  SET_UNKNOWN_PAA,
  SET_PHONE_NUMBER,
  RESET_STATE,
  SET_JOB_FUNCTIONS,
  SET_PERMISSIONS,
  SUBMIT_TIN_REQUEST,
} from './constants';

const initialState = {
  selectedAdmin: null,
  unknownPAA: false,
  phone: '',
  phoneExt: '',
  selectedJobFunctions: null,
  selectedPermissions: [],
  submitSUIINSaga: { isLoading: false, isError: false, isSuccess: false },
};

export const standardUserReducer = createReducer(initialState, {
  [SELECT_ADMIN]: (state, action) => {
    return {
      ...state,
      selectedAdmin: action.payload,
    };
  },
  [SET_JOB_FUNCTIONS]: (state, action) => {
    return {
      ...state,
      selectedJobFunctions: action.payload,
    };
  },
  [SET_UNKNOWN_PAA]: (state, action) => {
    return {
      ...state,
      unknownPAA: action.payload,
    };
  },
  [SET_PHONE_NUMBER]: (state, action) => {
    return {
      ...state,
      ...action.payload,
    };
  },
  [RESET_STATE]: (state, action) => {
    return { ...initialState };
  },
  [SET_PERMISSIONS]: (state, action) => {
    return {
      ...state,
      selectedPermissions: action.payload,
    };
  },
  [`${SUBMIT_TIN_REQUEST}_STARTED`]: (state, action) => {
    return {
      ...state,
      submitSUIINSaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${SUBMIT_TIN_REQUEST}_ERROR`]: (state, action) => {
    return {
      ...state,
      submitSUIINSaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
  [`${SUBMIT_TIN_REQUEST}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      submitSUIINSaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
});
